// extracted by mini-css-extract-plugin
export var container = "_sj-0";
export var inputWidth = "_sj-1";